import { render, staticRenderFns } from "./Equipments.vue?vue&type=template&id=06aa4e8f&scoped=true&"
import script from "./Equipments.vue?vue&type=script&lang=js&"
export * from "./Equipments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa4e8f",
  null
  
)

export default component.exports